import { createFileRoute, redirect } from "@tanstack/react-router";
import { SETTINGS_REDIRECTS } from "@/features/settings/sections";

/** Old URL (ALP-84 P4): the placeholder Billing page is gone; billing is a section of Plan & billing. */
export const Route = createFileRoute("/_app/settings/billing")({
  beforeLoad: () => {
    throw redirect({ ...SETTINGS_REDIRECTS["/settings/billing"], replace: true });
  },
});
